import React from "react";
import "../../../styles/css/creation-compte.css";
import srcIconLogo from "../../../styles/img/logo-kiuono-white.svg";
import { useState } from "react";
import _ from "lodash";
import { API } from "../../../const";
import { Service } from "../../../modules/service/service";
import { loadStripe } from "@stripe/stripe-js";
const LogoLogin = () => (
  <object
    data={srcIconLogo}
    type="image/svg+xml"
    className="img-fluid logo-login"
  />
);

export default function AbonnementInconnu(props) {
  const [choiceAbon, setChoice] = useState("");
  const [listFormules, setFormule] = useState({
    CRECHE_MENSUEL: {
      title: "Kiuono mensuel",
      price: "98€",
      avantages: [
        "Tablette prêtée",
        "Accès illimité",
        "Aucune restriction d'utilisation",
      ],
    },
    CRECHE_ANNUEL: {
      title: "Kiuono annuel",
      price: "998€",
      avantages: [
        "Tablette offerte",
        "Accès illimité",
        "Aucune restriction d'utilisation",
        "Support et formation",
      ],
    },
  });

  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  );

  async function handleSubmit(e) {
    e.preventDefault();
    const stripe = await stripePromise;

    if (!_.isEmpty(choiceAbon)) {
      const response = Service.post(
        `${API}api/creche/abonnements`,
        { abonnementType: choiceAbon },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      response.then((res) => {
        stripe.redirectToCheckout({
          sessionId: res.data.url,
        });
      });
    }
  }
  function handleChoice(event) {
    setChoice(event.target.value);
  }
  let formule2 = "CRECHE_MENSUEL";
  let formule1 = "CRECHE_ANNUEL";
  return (
    <main className="wrapper-creation-compte align-items-center justify-content-between">
      <div className="panel">
        <form className="form-account">
          <div className="creation-step">
            <h1>Choisissez votre abonnement</h1>
            <div
              className="row align-items-center row-formules"
              style={{ flexWrap: "unset" }}
            >
              <div className="col-lg-6">
                <div className="bande-formule formule1">
                  <div className="title">{listFormules[formule1].title}</div>
                  <div className="price">
                    {listFormules[formule1].price} <small>HT / an</small>
                  </div>
                  <ul className="list-avantages">
                    {listFormules[formule1].avantages.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                  <input
                    onClick={handleChoice}
                    type="radio"
                    id="aboAnnuel"
                    name="choix-abo"
                    value="CRECHE_ANNUEL"
                  />
                  <label htmlFor="aboAnnuel" className="btn-white txt-black">
                    <span className="off">Choisir</span>
                    <span className="on">Sélectionné</span>
                  </label>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="bande-formule formule2">
                  <div className="title">{listFormules[formule2].title}</div>
                  <div className="price">
                    {listFormules[formule2].price} <small>HT / mois</small>
                  </div>
                  <ul className="list-avantages">
                    {listFormules[formule2].avantages.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                  <input
                    onClick={handleChoice}
                    type="radio"
                    id="aboMensuel"
                    name="choix-abo"
                    value="CRECHE_MENSUEL"
                  />
                  <label htmlFor="aboMensuel" className="btn-white txt-black">
                    <span className="off">Choisir</span>
                    <span className="on">Sélectionné</span>
                  </label>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center boutons-actions">
              <a
                href=""
                onClick={handleSubmit}
                className="btn-gradient btn-next"
              >
                Créer mon compte
              </a>
            </div>
          </div>

          <div className="logo">
            <LogoLogin />
          </div>
        </form>
      </div>
    </main>
  );
}
